module.exports = __webpack_public_path__ + "media/dogs/dogs-medical-info-351ede70.svg";